import { css } from '@emotion/react';

export const dividerCx = css`
  background-color: #ededed;
`;
